import { Typography, IconButton, Popper, Grid } from '@mui/material';
import ShoppingCartCheckoutOutlinedIcon from '@mui/icons-material/ShoppingCartCheckoutOutlined';
import { useSelector } from 'react-redux';
import Text from './Text';
import { style } from 'constant/constants';
import { useState } from 'react';
import { getBracketImageWithPrice } from 'pages/calculator/calculatorUtils';

const textBoxStyles = { ml: 6.1 };
const divStyles = { display: 'flex', justifyContent: 'space-between' };

const BracketsCart = () => {
  const { selectedImages, bracketImagesWithPrices } = useSelector((store) => store.bracketOptions);
  const { calcResults } = useSelector((store) => store.calculations);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleToggleOpen = (event) => {
    console.log(selectedImages);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  // refactor from here as code is also in a fuction in main bracket calc
  const bracketData = selectedImages?.filter(
    (image) => image?.label === 'Snow Bracket Type' || image?.label === 'Snow Bracket Material'
  );

  const pricedBracket = getBracketImageWithPrice(selectedImages, bracketImagesWithPrices);

  const emptyCartMessage = <Typography variant="body2">Your cart is empty.</Typography>;

  let cartItemsContent = null;
  if (bracketData?.length > 0) {
    const material = pricedBracket?.materials?.find(
      (material) => material?.material === bracketData[1]?.title
    );
    const price = material?.price;

    cartItemsContent = (
      <>
        <Grid display="flex" alignItems="center">
          <img
            style={{ width: 40, border: '1px solid black', borderRadius: 4, marginRight: 8 }}
            src={bracketData[0]?.iconUrl}
          />
          <Text variant="body1">
            <b>{bracketData[0]?.title}</b>
          </Text>
        </Grid>
        {bracketData?.length > 1 && (
          <>
            <Text variant="body2" sx={textBoxStyles}>
              <div style={divStyles}>
                <span>Material: </span>
                <span>{bracketData[1]?.title}</span>
              </div>
            </Text>
            <Text variant="body2" sx={textBoxStyles}>
              <div style={divStyles}>
                <span>Price: </span>
                <span>$ {price}</span>
              </div>
            </Text>
          </>
        )}
        {calcResults?.totalBracketsForRoofingSquares > 0 && (
          <>
            <Text variant="body2" sx={textBoxStyles}>
              <div style={divStyles}>
                <span>Total Brackets: </span>
                <span>{calcResults?.totalBracketsForRoofingSquares}</span>
              </div>
            </Text>
            <Text variant="body2" sx={textBoxStyles}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontWeight: 'bold',
                  color: style.LIGHT.primary
                }}>
                <span>Total Price: </span>
                <span>$ {(calcResults?.totalBracketsForRoofingSquares * price)?.toFixed(2)}</span>
              </div>
            </Text>
          </>
        )}
      </>
    );
  }

  return (
    <div>
      <IconButton sx={{ mt: '2.3vh', borderRadius: 8 }} color="white" onClick={handleToggleOpen}>
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <Text sx={{ color: style.LIGHT.primary }}>View Cart</Text>
          </Grid>
          <Grid item>
            <ShoppingCartCheckoutOutlinedIcon style={{ color: style.LIGHT.primary }} />
          </Grid>
        </Grid>
      </IconButton>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        sx={{
          backgroundColor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0px 4px 8px rgb(0 0 0 / 0.1)',
          p: '0.75rem',
          opacity: 1,
          my: '0.25rem',
          width: 400
        }}>
        {!cartItemsContent && <div>{emptyCartMessage}</div>}
        {cartItemsContent}
      </Popper>
    </div>
  );
};

export default BracketsCart;
